import React from 'react';

import Polyline from './map/Polyline';
import { Tooltip, CircleMarker } from 'react-leaflet';

const buildLineFromLegs = ({ legs = [], ports = {} }) => {
  return legs.reduce((line, leg) => {
    // Find appropriate source for line on this leg
    if (leg.calc_route && leg.calc_route.length > 2) {
      return line.concat(leg.calc_route);
    } else if (leg.man_route) {
      return line.concat(leg.man_route);
    } else if (leg.calc_route) {
      return line.concat(leg.calc_route);
    } else {
      // Set line as a straight line between start and end port
      const startPort = ports[leg.start_port];
      const endPort = ports[leg.end_port];
      startPort && line.push([startPort.port_latitude, startPort.port_longitude]);
      endPort && line.push([endPort.port_latitude, endPort.port_longitude]);
      return line;
    }
  }, []);
};

const ShippingRoute = ({ route, selected, onClick }: {
  route: {};
  selected: boolean;
  onClick: Function;
}) => {
  let legs = [];
  let ports = {};
  if (route && route.description) {
    legs = route.description.legs;
    ports = route.description.ports;
  }
  return (
    <div>
      <Polyline
        positions={buildLineFromLegs({ legs, ports })}
        onClick={onClick}
        color={selected ? '#0176C8' : '#333'}
        opacity={selected ? 1 : 0.2}
        weight={5}
      />
      {selected && route && route.description && route.description.ports &&
        Object.keys(route.description.ports).map(port_cd => {
          const port = route.description.ports[port_cd];
          return (port && typeof port === 'object' && port.port_latitude && port.port_longitude &&
            <CircleMarker
              key={port_cd}
              center={[port.port_latitude, port.port_longitude]}
              color="#0176C8"
              radius={5}
              fill={true}
              fillOpacity={1}
            >
              <Tooltip>
                <span>{port.port_name}</span>
              </Tooltip>
            </CircleMarker>);
        })
      }
    </div>
  );
};

export default ShippingRoute;